var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('h1',[_vm._v("History")]),_c('p',[_vm._v("Under construction")])])}]

export { render, staticRenderFns }